export {
  DEFAULT_PURCHASE_ORDER_AMOUNT_ROUNDING_MODE,
  PURCHASE_ORDER_AMOUNT_ROUNDING_MODE_LABELS,
  PURCHASE_ORDER_AMOUNT_ROUNDING_MODES,
  parsePurchaseOrderAmountRoundingMode,
  purchaseOrderAmountRoundingModeLabel,
  purchaseOrderLineExtendedAmount,
  purchaseOrderOrderTotal,
  type PurchaseOrderAmountRoundingMode,
} from "@integrator-src/mrp/purchase-order-amount-rounding";

import {
  parsePurchaseOrderAmountRoundingMode as parseRoundingMode,
  purchaseOrderLineExtendedAmount as lineExtendedAmount,
  type PurchaseOrderAmountRoundingMode,
} from "@integrator-src/mrp/purchase-order-amount-rounding";

export const PURCHASE_ORDER_AMOUNT_ROUNDING_HOVER_HINT =
  "Unit prices keep every saved fraction of a penny. Choose whether to round to cents after quantity times unit price on each line, or add the unrounded line amounts and round only the order total.";

export function formatPurchaseOrderLineAmount(
  amount: number | null | undefined,
  currency: string | null | undefined,
  mode: PurchaseOrderAmountRoundingMode,
): string {
  if (amount == null || !Number.isFinite(amount)) return "—";
  const formatted = amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: mode === "order" ? 8 : 2,
  });
  const code = currency?.trim();
  return code ? `${code} ${formatted}` : formatted;
}

export function draftLineExtendedAmount(
  quantityRaw: string,
  unitPriceRaw: string,
  mode: PurchaseOrderAmountRoundingMode,
): number | null {
  const quantity = Number.parseFloat(quantityRaw);
  const unitPrice = Number.parseFloat(unitPriceRaw);
  if (!Number.isFinite(quantity) || !Number.isFinite(unitPrice)) {
    return null;
  }
  return lineExtendedAmount(quantity, unitPrice, parseRoundingMode(mode));
}
